/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
* Product Notification Timer
*/

function getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
}
  
function initializeClock(id, endtime) {
    const clock = document.getElementById(id);
    const daysSpan = clock.querySelector('.days');
    const hoursSpan = clock.querySelector('.hours');
    const minutesSpan = clock.querySelector('.minutes');
    const secondsSpan = clock.querySelector('.seconds');

    const timeinterval = setInterval(updateClock, 1000);
    function updateClock() {
      const t = getTimeRemaining(endtime);
      if (t.total <= 0) {
        clearInterval(timeinterval);
        clock.parentElement.style.display = "none";
        console.log(id + ': Product Notification Stopped.');
      } else {
        daysSpan.innerHTML = t.days;
        hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
        minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
        secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
      }
    }
}

function initProductNotificationTimer() {
  var clockElement = document.getElementsByClassName("product-notification-timer");
  for (var i = 0; i < clockElement.length; i++) {
      let deadline = clockElement[i].getAttribute('notify-end-time');
      initializeClock(clockElement[i].id, deadline);
  }
}
document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    initProductNotificationTimer();
  }
};

window.addEventListener('scroll', function () {
  const fixedElement = document.getElementById('mobile-facet-toolbar');
  // console.log(fixedElement)
  const targetSection = document.querySelector('.shopify-section--main-collection');
  // console.log(targetSection)

  // Get the position of the target section
  const rect = targetSection.getBoundingClientRect();
  // console.log(rect)

  // Check if the target section is in the viewport
  if (rect.top < window.innerHeight && rect.bottom > 0) {
    // Show the fixed element if the target section is in view
    fixedElement.style.display = 'flex';
  } else {
    // Hide the fixed element otherwise
    fixedElement.style.display = 'none';
  }
});



// function initializeMobileFilters() {
//    const filterList = document.querySelector(".mobile-facet-filters .product-facet__filter-list");

//    const filterButton = document.querySelector('.mobile-toolbar__item--filters');

//     if (!filterButton) return;
  
//     filterButton.addEventListener('click', function () {
//       if (filterButton.getAttribute('aria-expanded') === 'true') {
//         const buttons = filterList.querySelectorAll(".mobile-facet-filters .collapsible-toggle");
//         if (buttons.length > 0) {
//           buttons.forEach((button, index) => {
//             if (index === 0) {
//               button.setAttribute("aria-expanded","true");
//               button.style.borderLeft = "2px solid #1D7B74";
//               button.style.fontWeight = '500';
//               button.style.backgroundColor = "#FFFFFF"; 
//             } else {
//               button.setAttribute("aria-expanded","false");
//               button.style.backgroundColor = "#F4F4F4";
//               button.style.borderLeft = "0px";
//               button.style.fontWeight = '400';
//               button.style.overflow = "hidden";
//             }
//           });
//         } 
//       }
//     });

    

//     function handleButtonClick(event) {
//       const clickedButton = event.target.closest(".mobile-facet-filters .collapsible-toggle");
//       if (!clickedButton) return;

//       const buttons = filterList.querySelectorAll(".mobile-facet-filters .collapsible-toggle");

//       buttons.forEach((button) => {
//         button.setAttribute(
//           "aria-expanded",
//           button === clickedButton ? "true" : "false"
//         );
//         button.style.borderLeft = (button === clickedButton ? "2px solid #1D7B74" : "0px");
//         button.style.background = (button === clickedButton ? "#FFFFFF" : "#F4F4F4")
//         button.style.fontWeight = (button === clickedButton ? "500" : "400")
//       });
//     }

//     function applyBehaviorBasedOnScreenWidth() {
//       if (window.innerWidth <= 740) {
//         // Attach event listener if not already attached
//         if (!filterList.dataset.behaviorApplied) {
//           filterList.addEventListener("click", handleButtonClick);
//           filterList.dataset.behaviorApplied = "true";
//         }
//       } else {
//         // Remove event listener if screen width > 740px
//         if (filterList.dataset.behaviorApplied) {
//           filterList.removeEventListener("click", handleButtonClick);
//           filterList.dataset.behaviorApplied = "";
//         }
//       }
//     }

//     function toggleFacetFilters() {
//       const desktopFilters = document.querySelector('.desktop-facet-filters');
//       const mobileFilters = document.querySelector('.mobile-facet-filters');
//       const isMobile = window.innerWidth <= 740; // Define the mobile breakpoint
  
//       if (isMobile) {
//           // Remove desktop filters in mobile view
//           desktopFilters?.remove();
//       } else {
//           // Remove mobile filters in desktop view
//           mobileFilters?.remove();
//       }
//   }
  
//   // Initial check when the page loads
//   toggleFacetFilters();

//     applyBehaviorBasedOnScreenWidth();

//   function clearFilters() {
//     const clearFilterButton = document.querySelector('.mobile-facet-filters .drawer__header .drawer__header-action');
    
//     clearFilterButton.addEventListener("click", () => {
//       const checkboxes = document.querySelectorAll('.mobile-facet-filters .product-facet__filter-list .checkbox');
//       const filterSliders = document.querySelectorAll('.mobile-facet-filters .product-facet__filter-list .price-range__range-group');
//       const filterSliderInputs = document.querySelectorAll('.mobile-facet-filters .product-facet__filter-list .price-range__input-group');

//     filterSliders.forEach((slider, index) => {
//         // Get the inputs inside the current slider
//         const inputs = slider.querySelectorAll('input');
//          inputs[0].value = inputs[0].min;

//           // Set the second input's value to its max value
//           inputs[1].value = inputs[1].max;
//           slider.style.setProperty('--range-min', `0%`);
//           slider.style.setProperty('--range-max', `100%`);
//       });
//       filterSliderInputs.forEach((sliderInput, index) => {
//         const inputs = sliderInput.querySelectorAll('.price-range__input');
//         const inputMinVal = inputs[0].querySelector('input');
//         const inputMaxVal = inputs[1].querySelector('input');
//         inputMinVal.value = inputMinVal.min;
//         inputMaxVal.value = inputMaxVal.max;
//       })
      
//       checkboxes.forEach(function(checkbox) {
//       // If the checkbox is unchecked, we uncheck it
//         if (checkbox.checked) {
//           checkbox.checked = false;
//         }
//       });
//     });
//   }

//   clearFilters();
// }


// document.addEventListener("DOMContentLoaded", () => {
//     initializeMobileFilters()
// });

// document.addEventListener("facet:criteria-changed", () => {
//     initializeMobileFilters()
// });

//Function to handle loading in add to cart button
function toggleButtonLoader(btn, isLoading) {
  const textSpan = btn.querySelector('.loader-button__text');
  const loaderSpan = btn.querySelector('.loader-button__loader');

  if (!textSpan || !loaderSpan) return;

  if (isLoading) {
    // Hide text
    textSpan.hidden = true;
    textSpan.style.opacity = '0';

    // Show loader
    loaderSpan.hidden = false;
    loaderSpan.style.opacity = '1';
    loaderSpan.style.transform = 'translate(-50%, -50%)';

    btn.disabled = true;
  } else {
    // Show text
    textSpan.hidden = false;
    textSpan.style.opacity = '';

    // Hide loader
    loaderSpan.hidden = true;
    loaderSpan.style.opacity = '';
    loaderSpan.style.transform = '';

    btn.disabled = false;
  }
}

function addAndOpenShopflo(btn) {

  console.log("->>>>>->>>>>  comming here ->>>>>->>>>>")

  // 1. Prevent default form submission immediately
  event.preventDefault();
  event.stopPropagation();

  const form = btn.closest('form');
  if (!form) return;

  // 2. toggle Loader (Theme Specific)
  // We try to find the inner elements based on your HTML structure
  toggleButtonLoader(btn, true);

  // 3. Send data to Shopify
  const formData = new FormData(form);

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    // 4. Revert Loader
    toggleButtonLoader(btn, false);

    console.log(" window.handleFloCartBtn( ->>>>",  window.handleFloCartBtn)
    window.handleFloCartBtn()
    // 5. Trigger Shopflo
    // setTimeout(function() {
    //   Shopflo.openFloCart(); 
    // }, 1000);

  })
  .catch((error) => {
    console.error('Error:', error);
    toggleButtonLoader(btn, false);
  });
  
  return false;
}









